import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, MenuItem, Typography } from '@mui/material'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { motion } from 'framer-motion';

// COMPONENT
import Navbar from '../Navbar'
import Header from '../Header'
import * as styled from '../style/main.style'
import InputDatePicker from '../../../component/input/inputDatePicker'
import moment from 'moment'
import FilterSelect from '../../../component/select/filterSelect'
import SearchAutocompleteSelect from '../../../component/select/searchAutocompleteSelect'
import EastSharpIcon from '@mui/icons-material/EastSharp';
import AlertCustom from '../../../component/alert/AlertCustom'
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice'
import Loading from '../../../component/loading/Loading'
// import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

// TRANSITION
import { containerTransition, itemTransition } from '../../../constants/animation.framer'

// API
import { NotificationApi, notificationType } from '../../../api/notification/notification.api';
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api'
import { ProjectApi } from '../../../api/project/project.api'
// import { swalError, swalSuccess } from '../../../component/notification/swal'

type Props = {}
const Notification: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    moment.locale('th')

    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [statusCode, setStatusCode] = useState<string>("1");

    const [notification, setNotification] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);

    const handleGetNotification = useCallback(async () => {
        dispatch(setLoading())
        let condition: notificationType = {}
        if (startDate) condition = { ...condition, startDate: startDate }
        if (endDate) condition = { ...condition, endDate: endDate }
        if (statusCode !== "1") condition = { ...condition, statusCode: statusCode }
        if (idFiscalYear !== 0) condition = { ...condition, idFiscalYear: idFiscalYear }

        await NotificationApi.getNotification(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setNotification(res.data?.result?.items)
                } else {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [startDate, endDate, statusCode, idFiscalYear])

    // const handleDeleteNotification = async (idNotification: number) => {
    //     dispatch(setLoading())
    //     await NotificationApi.deleteNotification(idNotification)
    //         .then(res => {
    //             if (res.status === 200) {
    //                 dispatch(unsetLoading())
    //                 swalSuccess(res.data?.description)
    //             } else {
    //                 dispatch(unsetLoading())
    //                 swalError(res.response?.data?.description)
    //             }
    //         })
    //         .catch(error => {
    //             dispatch(unsetLoading())
    //             console.log(error)
    //         })
    //         .finally(() => handleGetNotification())
    // }

    const handleGetProjectStatus = async () => {
        // let condition:any = {}
        await ProjectApi.getAllProjectStatus()
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }


    useEffect(() => {
        handleGetNotification()
    }, [handleGetNotification])
    useEffect(() => {
        handleGetProjectStatus();
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <Typography className='text-primary' variant='h4'>
                            แจ้งเตือน
                        </Typography>
                    </styled.TopicHeader>
                    <styled.TopicFilterBox className='grid grid-cols-12 gap-1'>
                        <span className='col-span-12 lg:col-span-2'>
                            <InputDatePicker
                                headingNormal
                                inputName='startProject'
                                inputHeight={42}
                                dateFormat="DD/MM/YYYY"
                                key={"START_DATE"}
                                value={startDate}
                                placeholder={t('ระบุวันที่')}
                                onClear={() => setStartDate("")}
                                onChange={(e: any) => {
                                    setStartDate(moment(e).format("YYYY-MM-DD"))
                                }}
                                allowClear
                                heading={t("ตั้งแต่วันที่")}
                            />
                        </span>
                        <span className='col-span-12 lg:col-span-2'>
                            <InputDatePicker
                                disableStartDate={startDate}
                                disabled={startDate === ""}
                                headingNormal
                                inputName='endDate'
                                inputHeight={42}
                                dateFormat="DD/MM/YYYY"
                                key={"END_DATE"}
                                value={endDate}
                                placeholder={t('ระบุวันที่')}
                                onClear={() => setEndDate("")}
                                onChange={(e: any) => {
                                    setEndDate(moment(e).format("YYYY-MM-DD"))
                                }}
                                allowClear
                                heading={t("ถึงวันที่")}
                            />
                        </span>
                        <span className='col-span-12 lg:col-span-2'>
                            <SearchAutocompleteSelect
                                headingNormal
                                heading={t("ปีงบประมาณ")}
                                labelId="label-fiscal-year"
                                idKey="idFiscalYear"
                                value={idFiscalYear}
                                serverSearch={false}
                                fetchOptions={(condition) => FiscalYearApi.getFiscalYear(condition)}
                                getOptionLabel={(option) => String(option?.fiscalYear ?? '')}
                                onChange={(id) => setIdFiscalYear(id)}
                            />
                        </span>
                        <span className='col-span-12 lg:col-span-2'>
                            <FilterSelect
                                headingNormal
                                heading={t("สถานะโครงการ")}
                                renderValue={() => statusCode === "1" ? "ทั้งหมด" : projectStatus?.find((list: any) => list?.projectStatusCode === statusCode)?.projectStatusName}
                                selectId="select-typeOfMissionGroup"
                                value={statusCode}
                                labelId="label-typeOfMissionGroup"
                                onchange={async (event) => {
                                    const value = event.target.value
                                    value && setStatusCode(value)
                                }}
                                options={[
                                    <MenuItem onClick={() => setStatusCode("1")} value={0}>{"ทั้งหมด"}</MenuItem>,
                                    projectStatus && projectStatus?.map((list: any) => (
                                        <MenuItem key={list?.statusCode} value={list?.projectStatusCode}>
                                            {list?.projectStatusName}
                                        </MenuItem>
                                    ))]}
                            />
                        </span>
                    </styled.TopicFilterBox>
                    <styled.ContentBox
                        variants={containerTransition}
                        initial="hidden"
                        animate="visible"
                        transition={{ stiffness: 250, delay: .4 }}
                        className='flex flex-col gap-y-2'>
                        {notification.length > 0 ? notification.map((list: any,index:number) => (
                            <motion.div
                                key={index}
                                variants={itemTransition}
                                className='w-full cursor-pointer hover:shadow-lg h-full min-h-[232px] border-[1px] border-light rounded-lg relative flex flex-col md:flex-row gap-y-5 gap-x-8 p-5'>
                                <EastSharpIcon
                                    onClick={() => navigate('/auth/project-status/view', { state: list?.idProject })}
                                    className='absolute right-0 top-0 mt-3 mr-3 cursor-pointer' />
                                {/* <DeleteForeverOutlinedIcon
                                    onClick={() => handleDeleteNotification(list?.idNotification)}
                                    className='absolute right-0 bottom-0 md:1 md:mb-3 mr-1 md:mr-3 hover:scale-150 z-20 hover:animate-bounce delay-200 duration-200  cursor-pointer'
                                /> */}
                                <Box
                                    onClick={() => navigate('/auth/project-status/view', { state: list?.idProject })}
                                    className="flex flex-1 flex-col">
                                    <span className="text-2xl text-base_secondary">{moment(list?.createDate).format("DD")}</span>
                                    <span className='text-sm text-base_secondary'>{moment(list?.createDate).locale('th').format("MMMM")}</span>
                                </Box>
                                <Box
                                    onClick={() => navigate('/auth/project-status/view', { state: list?.idProject })}
                                    className="w-full flex flex-col gap-3 mr-24">
                                    <div className='flex flex-col'>
                                        <Typography className='text-primary' variant='h5'>
                                            {list?.projectName}
                                        </Typography>
                                        <Typography className='text-base_main' variant='h6'>
                                            {list?.projectPeriod}
                                        </Typography>
                                    </div>
                                    <Box
                                        onClick={() => navigate('/auth/project-status/view', { state: list?.idProject })}
                                        className="w-full">
                                        <AlertCustom
                                            text={list?.statusName}
                                            color={list?.statusCode}
                                        />
                                    </Box>
                                </Box>
                            </motion.div>
                        )) : (
                            <Typography className='text-base_disable mt-10' variant='h6'>ไม่มีข้อมูลการแจ้งเตือน</Typography>
                        )}
                    </styled.ContentBox>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default Notification